import tw, { styled } from "twin.macro"

const Lightbox = styled.div`
  ${tw`bg-black pointer-events-auto fixed w-full h-full top-0 left-0`}
  opacity: ${(props) => (props.opacity ? props.opacity / 100 : 0.9)};

  &.reports {
    background: rgba(18, 0, 36, 0.85);
  }

  &.newsroom {
    ${tw`opacity-100`}

    background: rgba(18, 0, 36, 0.85);
  }
`

export default Lightbox
